import { apiClient } from '@/lib/api-client';
import { reportSnapshotSchema } from '@/features/report-snapshots/api/schema';
import { queryOptions, useQuery, skipToken } from '@tanstack/react-query';

export const getReportSnapshot = async (shareToken: string) => {
  const response = await apiClient.get(`/ember/public/report_snapshots/${shareToken}`);

  return reportSnapshotSchema.parse(response);
};

export const getReportSnapshotQueryOptions = (shareToken: string | null) => {
  return queryOptions({
    queryKey: ['report-snapshot', shareToken],
    queryFn: shareToken ? () => getReportSnapshot(shareToken) : skipToken,
  });
};

export const useReportSnapshot = (shareToken: string | null) => {
  return useQuery({
    ...getReportSnapshotQueryOptions(shareToken),
  });
};
